









































import { ApprovalStatus } from '@/utils/types'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action } from 'vuex-class'

@Component
export default class ResetPassword extends Vue {
  approvalStatus = ApprovalStatus;
  reqStatus: ApprovalStatus = ApprovalStatus.PENDING;

  @Action sendDisallowEmailNotifications!: (payload: {
    jwt: string;
  }) => Promise<boolean>;

  async sendReq () {
    const isSuccessful = await this.sendDisallowEmailNotifications({
      jwt: this.$route.params.token
    })
    this.reqStatus = isSuccessful
      ? ApprovalStatus.APPROVED
      : ApprovalStatus.REJECTED
  }

  async mounted () {
    await this.sendReq()
  }
}
